import React, { useEffect, useState } from "react";
import SettingSidebar from "./SettingSidebar";
import Fotter from "./Fotter";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { BASE_URL } from "../Pages/Config";
import Cookies from "js-cookie";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export default function SettingMemberShip() {
  const [sessionUser, setSessionUser] = useState(null);
  const [activeProducts, setActiveProducts] = useState(null);
  const [membershipPlan, setMembershipPlan] = useState(null);

  const [TransactionCount, setTransactionCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    total: 0,
    paid: 0,
    pending: 0,
    pendingAmount: 0,
  });

  const userId = Cookies.get("user_id");

  // 🔹 Membership colors by type
  const membershipColors = {
    Basic: "green",
    Silver: "grey",
    Gold: "gold",
  };

  // 🔹 Fetch all data in parallel
  useEffect(() => {
    if (!userId) return;
    const timestamp = Date.now();

    Promise.all([
      axios.get(`${BASE_URL}/get_user_by_id.php?id=${userId}&t=${timestamp}`),
      axios.get(`${BASE_URL}/get_membership.php?id=${userId}&t=${timestamp}`),
      axios.get(
        `${BASE_URL}/get_active_products_by_user.php?id=${userId}&t=${timestamp}`,
      ),
    ])
      .then(([userRes, membershipRes, activeRes]) => {
        if (userRes.data.success) setSessionUser(userRes.data.data);
        if (membershipRes.data.success)
          setMembershipPlan(membershipRes.data.active);
        console.log("data", membershipRes);
        if (activeRes.data.success) setActiveProducts(activeRes.data.active);
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, [userId]);

  console.log("membership", activeProducts);

  useEffect(() => {
    axios
      .get(
        `${BASE_URL}/check_montly_user_transaction.php?user_id=${userId}&t=${Date.now()}`,
      )
      .then((res) => {
        console.log("Full response Transaction:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setTransactionCount(res.data.data);
        } else {
          setTransactionCount([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setTransactionCount([]);
      });
  }, [userId]);

  const usercharges = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${BASE_URL}/get_user_charges.php?user_id=${userId}&t=${Date.now()}`,
        { cache: "no-store" },
      );

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const data = await res.json();
      if (data.success) {
        // ✅ Calculate summary stats
        const total = data.data.length;
        let paid = 0,
          pending = 0,
          pendingAmount = 0;

        data.data.forEach((item) => {
          const isSeller = parseInt(userId) === parseInt(item.seller_id);
          const statusValue = isSeller
            ? item.charges_paid_status_seller
            : item.charges_paid_status_buyer;
          const isPaid = statusValue?.toLowerCase() === "paid";

          if (isPaid) {
            paid++;
          } else {
            pending++;
            pendingAmount += parseFloat(
              item.buy_product_status == 0 ? item.current_price : item.buy_now,
            );
          }
        });

        setStats({ total, paid, pending, pendingAmount });
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    usercharges();
  }, []);

  // console.log(sessionUser)

  // const [usermembership, setUserMembership] = useState(
  //   sessionUser?.membership_type || ""
  // );

  const upgrade = () => {
    navigate("/membership"); // redirect to /upgrade page
  };

  // console.log("user", sessionUser.membership_type);

  const Renew = () => {
    if (!sessionUser?.membership_end) {
      navigate("/membership");
      return;
    }

    const today = new Date();
    const endDate = new Date(sessionUser.membership_end);

    // ❌ Membership still active → do nothing / block
    if (endDate >= today) {
      toast.warning("Your membership is still active.");
      return;
    }

    // ✅ Membership expired → allow renew
    navigate("/membership");
  };

  const formatUTCDate = (utcString) => {
    if (!utcString) return "";

    const d = new Date(utcString);
    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };
  return (
    <>
      <Navbar />

      {/* Breadcrumb */}
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>
                <p>MY SUBSCRIPTION</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Section */}
      <div className="page-settings">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <SettingSidebar />

            {/* Content */}
            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12">
              <div className="col-12">
                <h2>
                  <b>My Membership</b>
                </h2>
              </div>

              {/* Current Membership */}
              <div className="setting-info">
                <div className="col-12">
                  <div className="member">
                    <div className="member-mass">
                      <div className="member-title mb-4 mt-2">
                        <b>Current membership details</b>
                      </div>

                      {/* Membership type */}
                      <div className="member-info-list">
                        <p style={{ fontWeight: "700" }}>Membership type: </p>
                        <p
                          style={{
                            color:
                              membershipColors[sessionUser?.membership_type] ||
                              "black",
                            fontWeight: "700",
                          }}
                        >
                          {sessionUser?.membership_type ?? "Loading..."}
                        </p>
                      </div>
                      {/* Remaining transactions */}
                      <div className="member-info-list">
                        <p style={{ fontWeight: "700" }}>
                          Remaining Listing Items Limit:{" "}
                        </p>
                        <p style={{ fontWeight: "700" }}>
                          {activeProducts !== null ? (
                            <>
                              <span
                                style={{
                                  color:
                                    sessionUser?.membership_type === "Basic"
                                      ? "red"
                                      : sessionUser?.membership_type ===
                                          "Silver"
                                        ? "orange"
                                        : sessionUser?.membership_type ===
                                            "Gold"
                                          ? "green"
                                          : "black",
                                }}
                              >
                                {activeProducts}
                              </span>
                              / {membershipPlan?.item_limit ?? "-"}
                            </>
                          ) : (
                            "Loading..."
                          )}
                        </p>
                      </div>

                      {/* Remaining transactions */}
                      <div className="member-info-list">
                        <p style={{ fontWeight: "700" }}>
                          Remaining item transactions:{" "}
                        </p>
                        <p style={{ fontWeight: "700" }}>
                          {activeProducts !== null ? (
                            <>
                              <span
                                style={{
                                  color:
                                    sessionUser?.membership_type === "Basic"
                                      ? "red"
                                      : sessionUser?.membership_type ===
                                          "Silver"
                                        ? "orange"
                                        : sessionUser?.membership_type ===
                                            "Gold"
                                          ? "green"
                                          : "black",
                                }}
                              >
                                {stats.pending}
                              </span>
                              {/* / {membershipPlan?.transaction_limit ?? "-"} */}
                            </>
                          ) : (
                            "Loading..."
                          )}
                        </p>
                      </div>

                      <div className="member-info-list">
                        <p style={{ fontWeight: "700" }}>Status:</p>
                        <p style={{ fontWeight: "700" }}>
                          {membershipPlan ? (
                            sessionUser.m_status === "Expired" ? (
                              <span style={{ color: "red" }}>Expired</span>
                            ) : (
                              <span style={{ color: "green" }}>Active</span>
                            )
                          ) : (
                            "Loading..."
                          )}
                        </p>
                      </div>

                      {sessionUser?.membership_type != "Basic" ? (
                        <>
                          <div className="member-info-list">
                            <p style={{ fontWeight: "700" }}>
                              Subscription Date:{" "}
                            </p>
                            <p style={{ fontWeight: "700" }}>
                              {membershipPlan
                                ? `${formatUTCDate(sessionUser.membership_start)} `
                                : "Loading..."}
                            </p>
                          </div>

                          <div className="member-info-list">
                            <p style={{ fontWeight: "700" }}>Ended Date: </p>
                            <p style={{ fontWeight: "700" }}>
                              {membershipPlan
                                ? ` ${formatUTCDate(sessionUser.membership_end)}`
                                : "Loading..."}
                            </p>
                          </div>
                        </>
                      ) : (
                        ""
                      )}

                      {/* Pay charges */}
                      {/* <div className="member-info-list">
                        <button
                          onClick={payCharges}
                          disabled={loading}
                          className="form-control mt-3"
                          style={{ backgroundColor: "#42B0FF", color: "white" }}
                        >
                          {loading ? "Processing..." : "Pay Charges"}
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Membership options */}
              <div className="setting-info mt-4">
                <div className="col-12">
                  <div className="member">
                    <div className="member-mass">
                      <div className="member-title">
                        <b>Membership options</b>
                      </div>
                      <div className="member-info-list">
                        <button
                          onClick={Renew}
                          className="form-control mt-3"
                          style={{ backgroundColor: "#42B0FF", color: "white" }}
                        >
                          Renew Membership
                        </button>
                        <button className="form-control mt-3" onClick={upgrade}>
                          Upgrade Membership
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fotter />

      <ToastContainer />
    </>
  );
}
